import ICON_SIZES_FOR_MAIN_MENU from 'constants/styles/ICON_SIZES_FOR_MAIN_MENU';

export const getIconSize = (isMobile: boolean) => ({
  width: `${isMobile ? ICON_SIZES_FOR_MAIN_MENU.sm.width : ICON_SIZES_FOR_MAIN_MENU.lg.width} !important`,
  height: `${isMobile ? ICON_SIZES_FOR_MAIN_MENU.sm.height : ICON_SIZES_FOR_MAIN_MENU.lg.height} !important`,
});
